import { render, staticRenderFns } from "./fccDataPeriodo.vue?vue&type=template&id=2160da18"
import script from "./fccDataPeriodo.vue?vue&type=script&lang=js"
export * from "./fccDataPeriodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports